import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../../auth/auth.service';
import { RedirectConstants } from '../../constants/redirect.constants';
import { GeneralRoutePaths, RouteQueryParams } from '../../enums/route-types.enum';

export const changeExpiringPasswordGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): boolean | Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.getUser()) {
    router.navigate([`/${GeneralRoutePaths.NEWS}`], {
      queryParams: { [RouteQueryParams.CHANGE_PASSWORD]: true },
    });

    return false;
  }

  sessionStorage.setItem(
    RedirectConstants.SESSION_STORAGE_KEY,
    JSON.stringify({ url: `/${GeneralRoutePaths.NEWS}?${RouteQueryParams.CHANGE_PASSWORD}=true` }),
  );
  router.navigate(['sign-in']);

  return false;
};
